module.exports = __webpack_public_path__ + "static/img3-c296f18a1de06a58ccd12da2393ca705.png";